<template>
  <div class="wrapper">
    <van-search
      v-model="keyword"
      shape="round"
      background="#368ad1"
      placeholder="请输入搜索关键词"
      @search="getList"
    >
      <template #action>
        <div @click="getList">搜索</div>
      </template>
    </van-search>
    <div class="padding-sm flex align-center justify-between flex-wrap">
      <router-link :to="'/expert/scoreFrist/'+item.id+'/' + id" class="org-item" v-for="item in list" :key="item.id">
        <h3 class="ovHide3">{{ item.title }}</h3>
      </router-link>

    </div>
    <van-empty description="暂无数据" v-if="noData"/>
  </div>
</template>

<script>
import {getOrgList} from "@/api/expert";

export default {
  name: "attendOrg",
  data() {
    return {
      id:'',
      keyword:'',
      list:[],
      noData:false
    }
  },
  created() {
    this.id= this.$route.params.id
    this.getList()
  },
  components: {},
  methods: {
    async getList(){
      const res =await getOrgList(this.id,this.keyword)
      this.list = res.data
      if(this.list.length === 0) {
        this.noData = true
      }else {
        this.noData = false
      }
    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.wrapper{
  .org-item{
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-direction: column;
    width: calc((100vw - 60px) / 2);
    height: 120px;
    padding: 20px;
    background:url(../../../assets/mImg/org_bg.png)#f6fbff no-repeat center;
    background-size: cover;
   border: 2px solid #dceaf7;
    border-radius: 8px;
    margin-bottom: 20px;
    h3{
      width: 100%;
      text-align: center;
    }
  }
}
</style>
